import {
    FETCH_LOYALTY_PROGRAM_MEMBERS,
    ADD_MEMBER_TO_LOYALTY_PROGRAM,
    GET_MEMBER_FROM_LOYALTY_PROGRAM,
    REMOVE_MEMBER_FROM_LOYALTY_PROGRAM
} from '../types';
import api from '../api';

export const fetchLoyaltyProgramMembers = (loyaltyProgramId, membersIds) => {
    return {
        type: FETCH_LOYALTY_PROGRAM_MEMBERS,
        payload: api.loyaltyProgram.get(loyaltyProgramId).members.getFull(membersIds),
    };
};

export const addMemberToLoyaltyProgram = (loyaltyProgramId, member) => {
    return {
        type: ADD_MEMBER_TO_LOYALTY_PROGRAM,
        payload: api.loyaltyProgram.get(loyaltyProgramId).members.add(member)
    };
};

export const removeMemberFromLoyaltyProgram = (loyaltyProgramId, memberId) => {
    return {
        type: REMOVE_MEMBER_FROM_LOYALTY_PROGRAM,
        payload: api.loyaltyProgram.get(loyaltyProgramId).members.remove(memberId)
    };
};
